import React from "react";
import { IonImg } from "@ionic/react";

const DifficultyIcon: React.FC<{ value: number; size: number }> = (props) => {
  //get difficulty level value and adjust it if the value out of range
  let value = Math.round(props.value);
  if (value <= 0) {
    value = 1;
  } else if (value > 3) {
    value = 3;
  }
  //image source
  let imageSource;
  if (value === 1) {
    imageSource = require("../assets/images/Beginner.png");
  } else if (value === 2) {
    imageSource = require("../assets/images/Intermediate.png");
  } else if (value === 3) {
    imageSource = require("../assets/images/Advanced.png");
  } else {
    imageSource = require("../assets/images/Beginner.png");
  }

  //return and render
  return (
    <IonImg
      src={imageSource}
      style={{
        width: props.size,
        height: props.size,
      }}
    />
  );
};

export default DifficultyIcon;
